module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_i-cb81dcce947534eb2e763f12b0ec0ee0.svg";